const DEFAULT_INACTIVITY_TIMEOUT = 3600000;
const DEFAULT_DIALOG_RESPONSE_TIMEOUT = 300000;

const parseTimeout = (
  value: string | undefined,
  fallbackValue: number
): number => {
  const parsedValue = Number(value);

  return Number.isFinite(parsedValue) && parsedValue > 0
    ? parsedValue
    : fallbackValue;
};

/**
 * Rotas publicas que nao devem iniciar o fluxo de logout por inatividade.
 */
export const INACTIVITY_EXCLUDED_PATHS = ['/', '/forgot', '/forgotNewPass'];

/**
 * Tempo maximo sem atividade antes de abrir o dialogo de confirmacao.
 */
export const INACTIVITY_TIMEOUT = parseTimeout(
  process.env.REACT_APP_INACTIVITY_TIMEOUT_MS,
  DEFAULT_INACTIVITY_TIMEOUT
);

/**
 * Tempo maximo para responder ao dialogo antes do logout definitivo.
 */
export const DIALOG_RESPONSE_TIMEOUT = parseTimeout(
  process.env.REACT_APP_INACTIVITY_DIALOG_TIMEOUT_MS,
  DEFAULT_DIALOG_RESPONSE_TIMEOUT
);

export const DIALOG_RESPONSE_TIMEOUT_IN_SECONDS =
  DIALOG_RESPONSE_TIMEOUT / 1000;
